import {
  Box,
  Button,
  Collapse,
  Divider,
  HStack,
  Icon,
  Input,
  Link,
  LinkBox,
  Text,
  Tooltip,
  useToast,
  VStack,
} from "@chakra-ui/react";
import AppIdentity from "components/AppIdentity";
import MemberIdentity from "components/MemberIdentity";
import MultiSelect from "components/MultiSelect";
import { useMemberAuthStore } from "modules/members/auth";
import { useState } from "react";
import { AiOutlineUserSwitch } from "react-icons/ai";
import { FiCheck, FiCheckCircle, FiUserX } from "react-icons/fi";
import { MdBlock } from "react-icons/md";
import { MFMember } from "state/members/member";
import MFMembers from "state/members/membersState";
import { MFOffboardingAccount } from "state/members/offboarding";
import { ACCOUNT_NOT_UPDATED } from "state/members/offboardingWrites";
import Linker from "ui/Linker";

const Row = ({
  account,
  showApp = true,
  type,
}: {
  account: MFOffboardingAccount;
  showApp?: boolean;
  type: "admin" | "account";
}) => {
  const status = account.status === "incomplete" ? "In complete" : "Complete";
  const [selectedAction, setSelectedAction] = useState<
    "removed" | "declined" | "transferred" | "not_req" | undefined
  >();
  const options = MFMembers.useListOptions();

  const [declinedReason, setDeclinedReason] = useState("");
  const { mutate: updateAccounts, isLoading } =
    MFMembers.useUpdateOffboardingAccounts(account.offboardingId);
  const toast = useToast();
  const [transferredToId, setTransferredToId] = useState<string>();

  // LOLOLOLOLOLOLOLOLOLOLOLOLOLOLOLOLOLOLOLOO
  // I've spent two weeks doing this offboaridng shit this
  // is not getting cleaned up
  const markAs = (
    removed: boolean,
    declined: boolean,
    transferred: boolean,
    transferNotRequired: boolean,
  ) => {
    updateAccounts({
      accountIds: [account.id],
      markRemoved: removed,
      markDeclined: declined,
      markTransferred: Boolean(
        (transferred && transferredToId) || transferNotRequired,
      ),
      adminRightsAssignedToId: transferred ? transferredToId : undefined,
      adminTransferNotRequired: transferNotRequired,
      declinedReason: declinedReason,
    }).then((written) =>
      toast(
        written
          ? { status: "success", title: "Accounts updated" }
          : ACCOUNT_NOT_UPDATED,
      ),
    );
    setDeclinedReason("");
    setSelectedAction(undefined);
  };
  const memberId = useMemberAuthStore((state) => state.id);

  const removalDisabledBecauseAdminTransfer =
    memberId === account.adminRightsAssigneeId &&
    !account.adminRightsConfirmedAt;

  return (
    <>
      <HStack
        w="full"
        opacity={
          (status === "Complete" && type === "account") ||
          (type === "admin" && account.adminRightsConfirmedAt)
            ? 0.5
            : 1
        }
      >
        <Box w={"65%"}>
          {account.memberAccount?.app && showApp ? (
            <AppIdentity app={account.memberAccount.app} size="sm" />
          ) : (
            <MemberIdentity member={account.memberAccount.member as MFMember} />
          )}
        </Box>
        <HStack spacing={3} justify="flex-end" w={"35%"}>
          {type === "admin" ? (
            !account.adminRightsConfirmedAt ? (
              <>
                <Button
                  variant="outline"
                  size="xs"
                  leftIcon={<Icon as={AiOutlineUserSwitch} />}
                  onClick={() => setSelectedAction("transferred")}
                  colorScheme="p"
                >
                  Transferred
                </Button>
                <Button
                  variant="outline"
                  onClick={() => setSelectedAction("not_req")}
                  size="xs"
                  leftIcon={<Icon as={FiCheck} />}
                  colorScheme="p"
                >
                  Not required
                </Button>
              </>
            ) : (
              <Icon as={FiCheckCircle} color="green.700" boxSize="18px" />
            )
          ) : status === "In complete" ? (
            type === "account" ? (
              <>
                <Tooltip
                  label={
                    removalDisabledBecauseAdminTransfer &&
                    "Requires admin transfer first"
                  }
                >
                  <Button
                    variant="primary"
                    onClick={() => setSelectedAction("removed")}
                    isDisabled={removalDisabledBecauseAdminTransfer}
                    size="xs"
                    leftIcon={<Icon as={FiUserX} />}
                    colorScheme="p"
                  >
                    Mark as Removed
                  </Button>
                </Tooltip>
                <Tooltip
                  label={
                    removalDisabledBecauseAdminTransfer &&
                    "Requires admin transfer first"
                  }
                >
                  <Button
                    variant="ghost"
                    onClick={() => setSelectedAction("declined")}
                    isDisabled={removalDisabledBecauseAdminTransfer}
                    size="xs"
                    leftIcon={<Icon as={MdBlock} />}
                    colorScheme="p"
                  >
                    Decline
                  </Button>
                </Tooltip>
              </>
            ) : (
              <HStack>
                <Text fontSize={"sm"} color="gray.600">
                  No more tasks at the moment
                </Text>
                <Icon as={FiCheckCircle} color="green.700" boxSize="18px" />
              </HStack>
            )
          ) : (
            <Icon as={FiCheckCircle} color="green.700" boxSize="18px" />
          )}
        </HStack>
      </HStack>
      <Collapse in={selectedAction !== undefined} style={{ width: "100%" }}>
        <Divider my={4} />
        <VStack
          w="full"
          py={4}
          px={4}
          bg="white"
          border="1px solid"
          borderColor="gray.100"
          rounded={8}
          spacing={4}
          align="flex-start"
          divider={<Divider />}
        >
          {selectedAction && (
            <VStack w="full" align="flex-start">
              <HStack w="full" justify={"space-between"}>
                <Text fontSize="sm" color="gray.900" w="80%">
                  {confirmationText[selectedAction]}
                </Text>
                <HStack>
                  <Button
                    variant="primary"
                    size="xs"
                    isLoading={isLoading}
                    isDisabled={
                      (selectedAction === "declined" &&
                        declinedReason.length < 3) ||
                      (selectedAction === "transferred" && !transferredToId)
                    }
                    onClick={() =>
                      markAs(
                        selectedAction === "removed",
                        selectedAction === "declined",
                        selectedAction === "transferred",
                        selectedAction === "not_req",
                      )
                    }
                  >
                    Yes
                  </Button>
                  <Button
                    variant="ghost"
                    onClick={() => setSelectedAction(undefined)}
                    size="xs"
                  >
                    Cancel
                  </Button>
                </HStack>
              </HStack>
              {selectedAction === "declined" && (
                <HStack w="full">
                  <Text
                    fontSize="sm"
                    color="gray.900"
                    w="80%"
                    fontWeight="500"
                  >
                    Decline reason
                  </Text>
                  <Input
                    size="sm"
                    value={declinedReason}
                    onChange={(e) => setDeclinedReason(e.target.value)}
                  />
                </HStack>
              )}
              {selectedAction === "transferred" && (
                <HStack justify={"flex-start"} w="100%" spacing={4}>
                  <Text
                    fontSize="sm"
                    color="gray.900"
                    w="80%"
                    fontWeight="500"
                  >
                    Transferred to
                  </Text>
                  <MultiSelect
                    options={options?.members || []}
                    onChange={({ value }) => setTransferredToId(value)}
                    isInvalid={!transferredToId}
                  />
                </HStack>
              )}
            </VStack>
          )}
        </VStack>
      </Collapse>
    </>
  );
};

const confirmationText = {
  removed:
    "I confirm I have removed the account from the application and the user can no longer access the application.",
  declined:
    "I can not remove the user from the application due to the provided reason",
  transferred:
    "I confirm I have transferred admin rights / role to the following employee for this application",
  not_req:
    "I confirm there is no need to transfer the admin rights for this application",
};

export default Row;
